import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { pesos, nombrePropio } from './formato';

// Pagina publica del QR de inspeccion ("Credencial digital" en la app del taxi).
// La abre un inspector o un pasajero escaneando el QR de Datos del Vehiculo.
const API_BASE = 'https://cyker.satelitax.com.ar/api';
const TEAL = '#74C8D2';
const TEXT1 = '#E6EDF3';
const TEXT2 = '#7D8590';
const SURFACE = '#161B22';
const BORDER = '#30363D';
const GREEN = '#22C55E';
const RED = '#EF4444';
const TZ = 'America/Argentina/Mendoza';

const CARD = {
  background: SURFACE,
  border: `1px solid ${BORDER}`,
  borderRadius: '16px',
  padding: '18px 20px',
  marginBottom: '12px',
};

const LABEL = {
  fontSize: '11px', color: TEXT2, letterSpacing: '2px',
  textTransform: 'uppercase', marginBottom: '12px', fontWeight: 600,
};

const fechaHora = (iso) => (iso
  ? new Date(iso).toLocaleString('es-AR', { timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
  : '—');
const hora = (s) => (s ? String(s).slice(0, 5) : '—');

function Fila({ label, value, fuerte }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', padding: '8px 0', borderBottom: `1px solid ${BORDER}` }}>
      <span style={{ color: TEXT2, fontSize: '14px' }}>{label}</span>
      <span style={{ color: TEXT1, fontSize: '15px', fontWeight: fuerte ? 700 : 500, textAlign: 'right' }}>{value}</span>
    </div>
  );
}

function Verificacion() {
  const { aditamento } = useParams();
  const [datos, setDatos] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/vehiculos/${encodeURIComponent(aditamento)}/verificacion`)
      .then(async (r) => {
        const j = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(j.error || 'No se pudo verificar el vehículo');
        return j;
      })
      .then(setDatos)
      .catch((e) => setError(e.message));
  }, [aditamento]);

  const t = datos && datos.tarifa;

  return (
    <div style={{ minHeight: '100vh', background: '#0D1117', color: TEXT1, fontFamily: 'Roboto, Segoe UI, sans-serif', padding: '0 16px 32px' }}>
      <div style={{ maxWidth: '480px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', padding: '20px 0 18px' }}>
          <img src="/logo_cyker_web.png" alt="Cyker" style={{ width: '120px', height: 'auto', display: 'block', margin: '0 auto 8px' }} />
          <div style={{ fontSize: '10px', color: TEXT2, letterSpacing: '4px', textTransform: 'uppercase' }}>Verificación de vehículo</div>
        </div>

        {!datos && !error && <div style={{ ...CARD, textAlign: 'center', color: TEXT2 }}>Consultando…</div>}

        {error && (
          <div style={{ ...CARD, borderColor: RED, textAlign: 'center' }}>
            <div style={{ color: RED, fontWeight: 700, fontSize: '18px', marginBottom: '6px' }}>No verificado</div>
            <div style={{ color: TEXT2, fontSize: '14px' }}>{error}. Número consultado: {aditamento}</div>
          </div>
        )}

        {datos && (
          <>
            <div style={{ ...CARD, borderColor: datos.habilitado ? GREEN : RED, textAlign: 'center' }}>
              <div style={{ color: datos.habilitado ? GREEN : RED, fontWeight: 800, fontSize: '20px', letterSpacing: '1px' }}>
                {datos.habilitado ? '✓ ALTA VIGENTE EN CYKER' : '✕ SIN ALTA VIGENTE'}
              </div>
              <div style={{ fontSize: '40px', fontWeight: 800, letterSpacing: '3px', margin: '12px 0 4px', fontFamily: 'Roboto Mono, Consolas, monospace' }}>
                {datos.patente || '—'}
              </div>
              <div style={{ color: TEXT2, fontSize: '13px' }}>Compare esta patente con la del vehículo</div>
              <div style={{ display: 'inline-block', marginTop: '12px', color: TEAL, fontWeight: 700, border: '1px solid rgba(116,200,210,0.3)', borderRadius: '20px', padding: '4px 16px' }}>
                Taxi {datos.aditamento}
              </div>
            </div>

            <div style={CARD}>
              <div style={LABEL}>Vehículo</div>
              <Fila label="Titular" value={nombrePropio(datos.titular) || '—'} fuerte />
              <Fila label="Marca y modelo" value={[datos.marca, datos.modelo].filter(Boolean).join(' ') || '—'} />
              <Fila label="Categoría" value={datos.categoria || '—'} />
              <Fila label="Precinto digital (placa)" value={datos.placa_vinculada ? 'Vinculada' : (datos.placa_requerida ? 'Falta vincular' : 'No requiere')} />
            </div>

            <div style={CARD}>
              <div style={LABEL}>Turno</div>
              {datos.en_turno
                ? <>
                    <Fila label="Chofer en turno" value={nombrePropio(datos.chofer) || '—'} fuerte />
                    <Fila label="Desde" value={fechaHora(datos.turno_desde)} />
                  </>
                : <div style={{ color: TEXT2, fontSize: '14px' }}>Sin turno abierto en este momento.</div>}
            </div>

            <div style={CARD}>
              <div style={LABEL}>Tarifa cargada</div>
              {t ? (
                <>
                  <Fila label="Bajada de bandera" value={pesos(t.bajada_bandera)} fuerte />
                  <Fila label={`Ficha (cada ${t.metros_por_ficha || '—'} m o ${t.segundos_espera_por_ficha || '—'} s de espera)`} value={pesos(t.precio_ficha)} />
                  <Fila label={`Nocturna (${hora(t.hora_inicio_nocturna)} a ${hora(t.hora_fin_nocturna)})`} value={`${pesos(t.bajada_bandera_nocturna)} · ficha ${pesos(t.precio_ficha_nocturna)}`} />
                  <Fila label="Vigente desde" value={fechaHora(t.created_at)} />
                </>
              ) : <div style={{ color: TEXT2, fontSize: '14px' }}>No hay tarifa cargada para esta categoría.</div>}
            </div>

            <div style={{ textAlign: 'center', color: TEXT2, fontSize: '12px', marginTop: '8px' }}>
              Consultado el {fechaHora(datos.consultado)} · La tarifa la carga solo el operador habilitado; el chofer no puede modificarla.
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Verificacion;
